// Кодмод Фазы 1 миграции на Vite (13.08.2026): require('*.png') → ESM-импорты.
// Vite не исполняет CommonJS в браузере ('require is not defined'); webpack
// понимает ESM-импорты ассетов так же (asset/resource → URL-строка).
import img0 from '@images/UI/Apps/apple.png';
import img1 from '@images/UI/Apps/apple@2x.png';
import img2 from '@images/UI/Apps/apple@3x.png';
import img3 from '@images/UI/Apps/google.png';
import img4 from '@images/UI/Apps/google@2x.png';
import img5 from '@images/UI/Apps/google@3x.png';
import img6 from '@images/UI/Apps/huawei.png';
import img7 from '@images/UI/Apps/huawei@2x.png';
import img8 from '@images/UI/Apps/huawei@3x.png';
import img9 from '@images/UI/Apps/rustore.png';
import img10 from '@images/UI/Apps/rustore@2x.png';
import img11 from '@images/UI/Apps/rustore@3x.png';

export default {
  Apps: {
    blackOnWhite: {
      apple: {
        x1: img0,
        x2: img1,
        x3: img2
      },
      google: {
        x1: img3,
        x2: img4,
        x3: img5
      },
      huawei: {
        x1: img6,
        x2: img7,
        x3: img8
      },
      rustore: {
        x1: img9,
        x2: img10,
        x3: img11
      }
    }
  }
};
